import { render, staticRenderFns } from "./AppsTab.vue?vue&type=template&id=65104ea0"
import script from "./AppsTab.vue?vue&type=script&lang=js"
export * from "./AppsTab.vue?vue&type=script&lang=js"
import style0 from "./AppsTab.vue?vue&type=style&index=0&id=65104ea0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports